import React from 'react';
import { useSelector } from 'react-redux';

import useSearchPagination from '../useSearchPagination';
import VWAProductList from '../../vwa/components/vwa-product-list';
import { transformProducts } from '../util';
import useProductImpressions from '../../hooks/useProductImpressionsV2';

import './css/search-page-product.less';

/**
 *
 * @param {*} props
 * @returns Tracks previous results
 */
const SearchProductResults = props => {
    const siteConfig = useSelector(state => state && state.siteConfig);
    const vanityUrl = useSelector(state => state && state.slugInfo && state.slugInfo.vanityUrl);
    const { basename } = siteConfig || {};
    const { setSearch, searchResults, currentSearch, currentPage, totalPages, gtmConfig, Keyword, searchKey, hsResID, query } =
        props;
    const paginatedSearchResults = useSearchPagination(searchResults, currentPage);
    let transformOpts = { disableMktDiff: true };
    let products = transformProducts(paginatedSearchResults, basename, transformOpts);
    let productBatch = transformProducts(searchResults, basename, transformOpts);

    const productsWithAnalytics = useProductImpressions({
        // products: (Keyword || '') === (searchKey || '') ? productBatch : null, // condition check is needed so searching within SRP triggers impressions correctly
        products,
        componentKey: 'hawksearchResults',
        list: 'search',
        vanityUrl,
        trackMetrics: true,
        trackerKey: query
    });

    return (
        <div className="hawk-results">
            {productsWithAnalytics && productsWithAnalytics.length > 0 && (
                <VWAProductList
                    products={productsWithAnalytics}
                    slugInfo={{
                        analyticsData: {
                            page_level: 'search',
                            hsResID,
                        },
                    }}
                    visId={true}
                    tileContainerProps={{ className: 'srp-product-tile' }}
                    useProductPromos={true}
                    maxResultsPerPage={24}
                />
            )}
        </div>
    );
};

export default SearchProductResults;
